import { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EquipmentSection from "@/components/EquipmentSection";
import WhyUs from "@/components/WhyUs";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import BookingDialog from "@/components/BookingDialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
  const [equipment, setEquipment] = useState([]);
  const [categories, setCategories] = useState(["All"]);
  const [loading, setLoading] = useState(true);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [selectedEquipment, setSelectedEquipment] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const [eqRes, catRes] = await Promise.all([
          axios.get(`${API}/equipment`),
          axios.get(`${API}/equipment/categories`),
        ]);
        setEquipment(eqRes.data);
        setCategories(catRes.data.categories || ["All"]);
      } catch (e) {
        console.error("Failed to load equipment", e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const openBooking = (eq) => {
    setSelectedEquipment(eq || null);
    setBookingOpen(true);
  };

  return (
    <main data-testid="home-page" className="min-h-screen bg-background">
      <Navbar onBookClick={() => openBooking(null)} />
      <Hero onBookClick={() => openBooking(null)} />
      <EquipmentSection
        equipment={equipment}
        categories={categories}
        loading={loading}
        onBook={openBooking}
      />
      <WhyUs />
      <About />
      <Contact />
      <Footer />

      <BookingDialog
        open={bookingOpen}
        onOpenChange={setBookingOpen}
        equipmentList={equipment}
        initialEquipment={selectedEquipment}
        apiUrl={API}
      />
    </main>
  );
}
